import React, { useState, useEffect } from 'react';
import Sidebar from '../Sidebar';
import { WizardProgress } from '../wizard/WizardComponents';
import ReviewSection from './ReviewSection';
import studentService from '../../services/studentService';

const RegistrationStep4 = ({ onNavigate, onSubmit, onLogout, photoFile: photoFileProp, docFiles: docFilesProp }) => {
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showPolicy,    setShowPolicy]    = useState(false);
  const [showError,     setShowError]     = useState(false);
  const [loading,       setLoading]       = useState(false);
  const [submitError,   setSubmitError]   = useState('');
  const [reviewData,    setReviewData]    = useState({ personal: [], family: [], permAddress: [], corrAddress: [], guardian: [], idProof: [], academic: [] });

  const createdRef = React.useRef(null);

  useEffect(() => {
    const s1 = JSON.parse(localStorage.getItem('registrationStep1Data') || '{}');
    const s2 = JSON.parse(localStorage.getItem('registrationStep2Data') || '{}');
    const s3 = JSON.parse(localStorage.getItem('registrationStep3Data') || '{}');
    const personal = [
      { label: 'Full Name',         value: s1.fullName       || 'Not provided' },
      { label: 'Date of Birth',     value: s1.dob            || 'Not provided' },
      { label: 'Gender',            value: s1.gender         || 'Not provided' },
      { label: 'Marital Status',    value: s1.maritalStatus  || 'Not provided' },
      { label: 'Religion',          value: s1.religion       || 'Not provided' },
      { label: 'Blood Group',       value: s1.bloodGroup     || 'Not provided' },
      { label: 'Mobile No.',        value: s1.mobile         || 'Not provided' },
      { label: 'Native Region',     value: s1.nativeRegion   || 'Not provided' },
      { label: 'Student Email ID',  value: s1.email          || 'Not provided' },
    ];
    const family = [
      { label: "Father's Name",       value: s1.fatherName   || 'Not provided' },
      { label: "Father's Mobile No.", value: s1.fatherMobile || 'Not provided' },
      { label: "Father's Email ID",   value: s1.fatherEmail  || 'Not provided' },
      { label: "Mother's Name",       value: s1.motherName   || 'Not provided' },
      { label: "Mother's Mobile No.", value: s1.motherMobile || 'Not provided' },
      { label: "Mother's Email ID",   value: s1.motherEmail  || 'Not provided' },
    ];
    const permAddress = [
      { label: 'Address Line 1', value: s1.permAddress1 || 'Not provided' },
      { label: 'Address Line 2', value: s1.permAddress2 || 'Not provided' },
      { label: 'City',           value: s1.permCity     || 'Not provided' },
      { label: 'Zip Code',       value: s1.permZipcode  || 'Not provided' },
      { label: 'State',          value: s1.permState    || 'Not provided' },
      { label: 'Country',        value: s1.permCountry  || 'Not provided' },
    ];
    const corrAddress = [
      { label: 'Address Line 1', value: s1.corrAddress1 || 'Not provided' },
      { label: 'City',           value: s1.corrCity     || 'Not provided' },
      { label: 'State',          value: s1.corrState    || 'Not provided' },
      { label: 'Country',        value: s1.corrCountry  || 'Not provided' },
    ];
    const guardian = [
      { label: "Local Guardian's Name", value: s1.localGuardianName || 'Not provided' },
      { label: 'Relation',              value: s1.guardianRelation  || 'Not provided' },
      { label: "Guardian's Mobile No.", value: s1.guardianMobile    || 'Not provided' },
      { label: 'Guardian Email ID',     value: s1.guardianEmail     || 'Not provided' },
      ...(s1.guardianIdType ? [
        { label: "Guardian's ID Type",   value: s1.guardianIdType === 'DrivingLicense' ? 'Driving License' : s1.guardianIdType === 'Aadhar' ? 'Aadhar Card' : 'Passport' },
        { label: "Guardian's ID Number", value: s1.guardianIdNumber || 'Not provided' },
      ] : []),
    ];
    const idProof = [
      { label: 'Aadhar Card No.',       value: s1.aadhar        || s3.aadharNumber         || 'Not provided' },
      { label: 'Emergency Contact No.', value: s1.emergencyContact || 'Not provided' },
      { label: 'Driving Licence No.',   value: s1.drivingLicense || s3.drivingLicenceNumber || 'Not provided' },
      { label: 'Passport No.',          value: s1.passport       || s3.passportNumber       || 'Not provided' },
      { label: 'PAN Card No.',          value: s1.panCard        || s3.panNumber            || 'Not provided' },
    ];
    const academic = [];
    if (s2.courses && s2.courses.length > 0) {
      s2.courses.forEach((c, i) => {
        if (c.universityName) {
          academic.push({ label: `University Name ${i + 1}`, value: c.universityName });
          academic.push({ label: `Academic Year ${i + 1}`,  value: c.academicYear });
          academic.push({ label: `Stream ${i + 1}`,         value: c.stream });
          academic.push({ label: `Timing ${i + 1}`,         value: c.timing });
          academic.push({ label: `Phone No. ${i + 1}`,      value: c.phoneNo });
        }
      });
    }
    if (s2.languages) {
      academic.push({ label: 'Languages (Write)', value: s2.languages.toWrite    || 'Not provided' });
      academic.push({ label: 'Languages (Speak)', value: s2.languages.toSpeak    || 'Not provided' });
      academic.push({ label: 'Languages (Read)',  value: s2.languages.toRead     || 'Not provided' });
      academic.push({ label: 'Mother Tongue',     value: s2.languages.motherTongue || 'Not provided' });
    }
    setReviewData({ personal, family, permAddress, corrAddress, guardian, idProof, academic });
  }, []);

  const handleSubmit = async () => {
    if (!termsAccepted) { setShowError(true); return; }
    setShowError(false); setLoading(true); setSubmitError('');
    setShowError(false); setLoading(true); setSubmitError('');
    try {
      // ✅ Resolve files from parent state (reliable), falling back to the
      //    older window.* / sessionStorage sources for safety.
      let photoFile = photoFileProp || window.selectedPhotoFile;
      if (!photoFile) {
        const savedPhoto = sessionStorage.getItem('regPhotoData');
        if (savedPhoto) {
          try {
            const { base64, name, type } = JSON.parse(savedPhoto);
            const byteStr = atob(base64.split(',')[1]);
            const arr = new Uint8Array(byteStr.length);
            for (let i = 0; i < byteStr.length; i++) arr[i] = byteStr.charCodeAt(i);
            photoFile = new File([arr], name, { type });
          } catch(e) { console.error('Could not restore photo', e); }
        }
      }
      const docFiles = docFilesProp || window.selectedDocFiles || null;

      // ✅ FAIL-LOUD GUARD — never create a student without required documents.
      // Required: at least one COMPLETE ID proof (front + back) AND the Light Bill.
      const complete = (f, b) => !!(docFiles && docFiles[f] && docFiles[b]);
      const hasCompleteIdProof =
        complete('aadharFront','aadharBack') ||
        complete('drivingLicenseFront','drivingLicenseBack') ||
        complete('passportFront','passportBack') ||
        complete('panFront','panBack');
      const hasLightBill = !!(docFiles && docFiles.lightBill);

      if (!hasCompleteIdProof || !hasLightBill) {
        setLoading(false);
        setSubmitError(
          'Your uploaded documents were not found — this can happen if the page reloaded during registration. ' +
          'Please go Back to the "Document Upload" step and re-attach your ID proof (front & back) and Light Bill, then submit again.'
        );
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      const s1 = JSON.parse(localStorage.getItem('registrationStep1Data') || '{}');
      const s2 = JSON.parse(localStorage.getItem('registrationStep2Data') || '{}');
      const s3 = JSON.parse(localStorage.getItem('registrationStep3Data') || '{}');

      // ✅ Strip spaces from mobile numbers — international numbers may have spaces (e.g. +44 20 7946 0958)
      const stripMobile = (m) => m ? m.trim().replace(/\s/g, '') : '';

      const registrationData = {
        fullName: s1.fullName, dob: s1.dob, gender: s1.gender,
        maritalStatus: s1.maritalStatus, religion: s1.religion, bloodGroup: s1.bloodGroup,
        nativeRegion: s1.nativeRegion,
        mobile: stripMobile(s1.mobile),       // ✅ strip spaces
        email: s1.email,
        fatherName: s1.fatherName,
        fatherMobile: stripMobile(s1.fatherMobile),   // ✅ strip spaces
        fatherEmail: s1.fatherEmail || '',
        motherName: s1.motherName || '',
        motherMobile: stripMobile(s1.motherMobile),   // ✅ strip spaces
        motherEmail: s1.motherEmail || '',
        permanentAddress: { address1: s1.permAddress1, address2: s1.permAddress2 || '', city: s1.permCity, zipcode: s1.permZipcode, state: s1.permState, country: s1.permCountry },
        correspondenceAddress: { address1: s1.corrAddress1, address2: s1.corrAddress2 || '', city: s1.corrCity, zipcode: s1.corrZipcode, state: s1.corrState, country: s1.corrCountry },
        localGuardianName: s1.localGuardianName || '', guardianRelation: s1.guardianRelation || '',
        guardianMobile: stripMobile(s1.guardianMobile),       // ✅ strip spaces
        guardianEmail: s1.guardianEmail || '',
        guardianIdType: s1.guardianIdType || '', guardianIdNumber: s1.guardianIdNumber || '',
        aadhar: s1.aadhar || s3.aadharNumber,
        emergencyContact: stripMobile(s1.emergencyContact),   // ✅ strip spaces
        drivingLicense: s1.drivingLicense || s3.drivingLicenceNumber || '',
        passport: s1.passport || s3.passportNumber || '',
        languagesToWrite: s2.languages?.toWrite || '', languagesToSpeak: s2.languages?.toSpeak || '',
        languagesToRead: s2.languages?.toRead || '', motherTongue: s2.languages?.motherTongue || '',
        courses: (s2.courses || []).filter(c => c.universityName && c.academicYear && c.stream).map(c => ({
          universityName: c.universityName, academicYear: c.academicYear, stream: c.stream, timing: c.timing, phoneNo: c.phoneNo,
        })),
        termsAccepted: true,
      };
      // Reuse the already-created student on a retry; only register once.
      let response;
      if (createdRef.current) {
        response = createdRef.current;
      } else {
        response = await studentService.registerStudent(registrationData);
        createdRef.current = response;
      }
      const studentId = response.id;

      // Photo is optional — upload if present (best-effort).
      if (photoFile && studentId) {
        try { await studentService.uploadPhoto(studentId, photoFile); } catch(e) { console.error('Photo upload failed:', e); }
      }
      // Documents are REQUIRED. The upload is the step that fails on flaky
      // mobile connections, so we retry once, and if it STILL fails we stop
      // and tell the user — rather than silently saving a student with no docs.
      if (docFiles && studentId) {
        let docUploaded = false;
        for (let attempt = 1; attempt <= 2 && !docUploaded; attempt++) {
          try {
            await studentService.uploadIdProofs(studentId, docFiles);
            docUploaded = true;
          } catch (e) {
            console.error(`Doc upload attempt ${attempt} failed:`, e);
            if (attempt === 2) {
              window.selectedDocFiles = docFiles;
              setLoading(false);
              setSubmitError(
                'Your registration was saved, but the document upload did not complete ' +
                '(this can happen on a slow connection). Your documents are still attached — ' +
                'please press Submit again to finish uploading them. ' +
                'If it keeps failing, try a stronger network or smaller images (JPG/PNG/PDF, not HEIC).'
              );
              window.scrollTo({ top: 0, behavior: 'smooth' });
              return;
            }
          }
        }
      }
      const guestMobileForReg = localStorage.getItem('guestMobile') || registrationData.mobile || '';
      localStorage.setItem('completeRegistrationData', JSON.stringify({ ...registrationData, registrationId: response.registrationId, id: response.id, status: response.status, submittedAt: new Date().toISOString(), mobile: registrationData.mobile || guestMobileForReg }));
      localStorage.removeItem('registrationPhotoPreview');
      sessionStorage.removeItem('regPhotoData');
      window.selectedPhotoFile = null;
      window.selectedDocFiles = null;
      createdRef.current = null;   // ✅ reset so the NEXT registration starts fresh
      onSubmit();
    } catch (error) {
      setSubmitError(error.errors ? Object.entries(error.errors).map(([f,m]) => `${f}: ${m}`).join('\n') : (error.message || 'Failed to submit registration.'));
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } finally { setLoading(false); }
  };

  const RULES = [
    'Accommodation is provided with the understanding that the resident student will strictly adhere to the rules and regulations that are currently in force or may be enforced from time to time.',
    'Housing cannot be claimed as a matter of right.',
    'The Omkara-1 administration can deny accommodation to any student who is known to have violated the rules or whose presence is likely to disturb the peace and tranquility of the accommodation.',
    'Violation of accommodation rules will make the student liable for disciplinary action, including permanent eviction from the residential building.',
    'Students should remember that this hostel is their "second home." Therefore, they should behave in a manner, both on and off-campus, that brings credit to themselves and the institution.',
    'Omkara Hostel residents are not allowed to use any electrical appliances (e.g., KETTLE, INDUCTION, IRON, etc.) in the rooms. Any appliance found being used will be confiscated and not returned.',
    'Residents should not paste any POSTERS or PICTURES on the walls, doors, cupboards, or windows. A fine of Rs. 3,000/- will be Charged for violations.',
    'Visitors: Outsiders are NOT ALLOWED in the hostel or the rooms. If an outsider is found in a room, a fine of Rs. 1,000/- will be Charged.',
    'Laundry Services: Laundry is chargeable at Rs. 20/- per cloth for basic washing and pressing. No valuable or expensive clothing should be given for laundry. The hostel authority will not take responsibility for any damage or loss.',
    'Enrollment & Rent: Once enrolled in Omkara-1, a student remains a resident for the entire academic year. Even if a student is prohibited from staying due to disciplinary reasons, they must pay the room rent for the entire year. Ignorance of the rules will not be accepted as an excuse.',
    'Inspection: The warden or authorized staff has the right to inspect any room at any time for security or disciplinary reasons.',
    'Silence Hours: Quiet hours are observed from 10:00 p.m. to 6:00 a.m. to allow for study and sleep. Loud music or noise is strictly prohibited during this time.',
    'Room Allotment: Every student must stay in their allotted room. Reciprocal exchange of rooms is not allowed. Only the administrator may allow an exchange as a special case. Any violation will be treated as gross misconduct and may lead to eviction and heavy fines.',
    'Valuable Items: The hostel authority will not take responsibility for the damage or loss of any expensive personal belongings.',
    'Prohibited Items: Usage or storage of LIQUOR, DRUGS, CIGARETTES, FLAVORED E-CIGARETTES, or any other INTOXICANTS in the OMKARA HOSTEL premises is strictly prohibited. If found, immediate action will be taken, the student will be evicted, and a fine of Rs. 5,000/- (Five Thousand only) will be Charged.',
    'Room Allotment: Hostel seats are allotted for the entire academic year. It is mandatory for residents to occupy their assigned rooms and not change them without prior permission from the hostel authority.',
    'General Duties: Students must check the notice board regularly. Any authorized member of the hostel staff may inspect a student\'s room at any time. Residents must carry a valid ID proof and present it to the authorities whenever requested.',
    'Complaints: It is mandatory to report any issues to the office. The complaint form should be sent via WhatsApp and signed by the tenant. Resolution will be completed within 6–8 days. Please note that complaints are registered only during office hours.',
    'Furniture & Fittings: Under no circumstances should any furniture be moved from one place to another. Students are responsible for taking care of the furniture and fittings in their rooms. In case of any loss or damage, the cost will be recovered from the student, and a charge of Rs. 5,000/- will apply.',
    'Outside Food: No outside food is allowed inside the hostel rooms. If found, a fine of Rs. 500/- will be Charged.',
    'Conduct & Eviction: If any student is found misbehaving or misconducting themselves, they will be evicted immediately, and fees will not be refunded.',
    'Vacation Policy: During long leaves or vacations, the hostel must be vacated and all luggage must be taken with the student. If a student wishes to continue their residency for the next session, they must submit the advance fees for the upcoming session.',
    'Fee Structure: Management reserves the right to increase the fee structure depending on market conditions.',
    'Legal Jurisdiction: Any legal disputes or claims arising from OMKARA HOSTEL-1 shall be subject to the exclusive jurisdiction of the courts in AHMEDABAD, GUJARAT.',
  ];

  const ACCOM = [
    'Payment Policy: Accommodation will be provided only after FULL PAYMENT of fees. Fees must be paid 100% in advance at the time of admission.',
    'Academic Period: The stated fees cover the period from 1st July 2026 to 31st May 2027 for the academic year.',
    'Room Allotment: Room allotment is based on availability and will be assigned in series for the academic year. No special preferences will be considered.',
    'Management Rights: All rights related to accommodation and management are reserved exclusively by OMKARA HOSTEL-1 MANAGEMENT.',
  ];

  const REFUND = [
    'No Refund: After joining, no refund will be granted under any circumstances.',
    'College Admission Exception: If a student must leave due to admission in a DIFFERENT COLLEGE IN ANOTHER CITY, the following rules apply — (i) Two months\' charges will be deducted from the total fees. (ii) The student must submit VERIFIED DOCUMENTS as proof for the refund to be processed.',
    'Balance & Deposit: Any Pay Card credit balance and security deposit amount will be refunded 90 [Ninety] days after the student officially leaves OMKARA HOSTEL-1.',
  ];

  const RuleItem = ({ text, bullet = '#' }) => (
    <div style={{ display:'flex', gap:10, marginBottom:10, fontSize:13, color:'#2C2C2C', lineHeight:1.6 }}>
      <span style={{ color:'#1B3B5F', fontWeight:700, flexShrink:0 }}>{bullet}</span>
      <span>{text}</span>
    </div>
  );

  return (
    <div className="app-layout">
      <Sidebar activeItem="registration" onNavigate={onNavigate} onLogout={onLogout} />
      <main className="main-content">
        <div className="top-bar"><h1 className="page-title">Final Review</h1></div>
        <div className="content-area">
          <div className="wizard-container">
            <div style={{ position:'relative', zIndex: showPolicy ? 0 : 'auto' }}>
              <WizardProgress currentStep={4} />
            </div>
            <div className="wizard-card">
              {submitError && (
                <div style={{ padding:15, marginBottom:20, background:'#fee', border:'1px solid #e74c3c', borderRadius:8, color:'#e74c3c', whiteSpace:'pre-line', fontSize:14 }}>{submitError}</div>
              )}
              <div className="review-grid">
                <div>
                  <ReviewSection title="Personal Details"           data={reviewData.personal} />
                  <ReviewSection title="Family Details"             data={reviewData.family} />
                  <ReviewSection title="Permanent Address"          data={reviewData.permAddress} />
                  <ReviewSection title="Correspondence Address"     data={reviewData.corrAddress} />
                  <ReviewSection title="Guardian Details"           data={reviewData.guardian} />
                  <ReviewSection title="ID Proof Details"           data={reviewData.idProof} />
                  <ReviewSection title="Course & Language Details"  data={reviewData.academic} />
                </div>
                <div className="review-sidebar">
                  <div className="review-card">
                    <div className="review-photo">
                      {localStorage.getItem('registrationPhotoPreview') ? (
                        <img src={localStorage.getItem('registrationPhotoPreview')} alt="Student"
                          style={{ width:120, height:120, objectFit:'cover', borderRadius:'50%' }} />
                      ) : (
                        <span style={{ fontSize:60 }}>👤</span>
                      )}
                    </div>
                    <div className="review-name">{reviewData.personal.find(i => i.label === 'Full Name')?.value || 'Name Not Provided'}</div>
                    <div className="review-id">Registration ID: Pending</div>

                    <div className="review-terms">
                      {showPolicy && (
                        <div style={{ position:'fixed', inset:0, zIndex:9999, background:'rgba(0,0,0,0.55)', display:'flex', alignItems:'center', justifyContent:'center', padding:16 }} onClick={() => setShowPolicy(false)}>
                          <div style={{ background:'#fff', borderRadius:8, maxWidth:760, width:'100%', maxHeight:'90vh', display:'flex', flexDirection:'column', boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }} onClick={e => e.stopPropagation()}>
                            <div style={{ padding:'14px 20px', borderBottom:'1px solid #E8E4DF', display:'flex', justifyContent:'space-between', alignItems:'center', flexShrink:0 }}>
                              <h2 style={{ margin:0, fontSize:16, fontWeight:700, color:'#1B3B5F' }}>Omkara Hostel — Rules &amp; Policies</h2>
                              <button onClick={() => setShowPolicy(false)} style={{ background:'none', border:'none', fontSize:24, cursor:'pointer', color:'#9B9B9B', lineHeight:1 }}>×</button>
                            </div>
                            <div style={{ overflowY:'auto', padding:'20px 24px', flex:1 }}>
                              <h3 style={{ fontSize:14, fontWeight:700, color:'#1B3B5F', textDecoration:'underline', marginBottom:14 }}>OMKARA HOSTEL RULES AND REGULATIONS</h3>
                              {RULES.map((rule, i) => <RuleItem key={i} text={rule} />)}
                              <div style={{ marginTop:24, paddingTop:18, borderTop:'2px solid #E8E4DF' }}>
                                <h3 style={{ fontSize:14, fontWeight:700, color:'#1B3B5F', textDecoration:'underline', marginBottom:12 }}>OMKARA HOSTEL-1 : ACCOMMODATION AND REFUND POLICY</h3>
                                {ACCOM.map((item, i) => <RuleItem key={i} text={item} bullet="•" />)}
                                <h4 style={{ fontSize:13, fontWeight:700, color:'#1B3B5F', marginTop:16, marginBottom:10, textDecoration:'underline' }}>REFUND POLICY</h4>
                                {REFUND.map((item, i) => <RuleItem key={i} text={item} bullet="•" />)}
                              </div>
                            </div>
                            <div style={{ padding:'14px 24px', borderTop:'1px solid #E8E4DF', display:'flex', justifyContent:'space-between', alignItems:'center', flexShrink:0 }}>
                              <span style={{ fontSize:12, color:'#9B9B9B' }}>Email: omkaraimpex1@gmail.com</span>
                              <button onClick={() => setShowPolicy(false)}
                                style={{ padding:'9px 24px', background:'#1B3B5F', color:'#fff', border:'none', borderRadius:4, cursor:'pointer', fontSize:13, fontWeight:600 }}>Close</button>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="checkbox-wrapper" style={{ marginTop:16 }}>
                        <input type="checkbox" id="terms" checked={termsAccepted}
                          onChange={e => { setTermsAccepted(e.target.checked); if (e.target.checked) setShowError(false); }}
                          disabled={loading} />
                        <label htmlFor="terms" style={{ color: showError && !termsAccepted ? '#e74c3c' : '#2C2C2C', fontSize:13, lineHeight:1.5 }}>
                          I have read and agree to the{' '}
                          <span onClick={e => { e.preventDefault(); setShowPolicy(true); }}
                            style={{ color:'#1B3B5F', fontWeight:700, textDecoration:'underline', cursor:'pointer' }}>
                            Rules &amp; Regulations and Refund Policy
                          </span>
                          {' '}of Omkara Hostel *
                        </label>
                      </div>
                      {showError && !termsAccepted && (
                        <div style={{ color:'#e74c3c', fontSize:12, marginTop:8, fontWeight:500, display:'flex', alignItems:'center', gap:4 }}>
                          <span>⚠️</span>
                          <span>Accept Rules &amp; Regulations and Refund Policy to submit your registration.</span>
                        </div>
                      )}
                    </div>

                    <div className="submit-actions">
                      <button className="btn-back" onClick={() => onNavigate('registration3', { isBack: true })} disabled={loading}>Back</button>
                      <div onClick={() => { if (!termsAccepted && !loading) setShowError(true); }} style={{ display:'inline-block', cursor: (!termsAccepted && !loading) ? 'not-allowed' : 'default' }}>
                        <button className="btn-submit" onClick={handleSubmit} disabled={loading || !termsAccepted} style={{ opacity: (termsAccepted && !loading) ? 1 : 0.7, pointerEvents: (!termsAccepted || loading) ? 'none' : 'auto' }}>
                          {loading ? 'Submitting...' : 'Submit'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default RegistrationStep4;